import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=07c262d5&"
import script from "./Create.vue?vue&type=script&lang=js&"
export * from "./Create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07c262d5')) {
      api.createRecord('07c262d5', component.options)
    } else {
      api.reload('07c262d5', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=07c262d5&", function () {
      api.rerender('07c262d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/PushNotifications/Components/Create.vue"
export default component.exports